module.exports = __webpack_public_path__ + "static/img/about-us-img@w.62c4044.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/about-us-img@w.png
// module id = 79Gb
// module chunks = 0